<template>
  <v-dialog :value="true" max-width="500" persistent>
    <v-card class="pa-4" flat>
      <v-form @submit.prevent="createGroup" v-model="isFormValid" ref="form">
        <v-card-title>Create group</v-card-title>
        <v-card-text
          ><div class="mb-1 subtitle-2 grey3--text">Group name</div>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            placeholder="Name"
            outlined
            dense
          ></v-text-field>
          <v-btn
            class="mt-2 primary white--text lowercase-text"
            block
            plain
            :loading="$store.state.loading.createGroupBtn.load"
            :disabled="$store.state.loading.createGroupBtn.disabled"
            type="submit"
          >
            Create group
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('close')">CLOSE</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 3) || "Name must be at least 3 characters",
      ],
      isFormValid: false,
    };
  },

  methods: {
    async createGroup() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("groups/createGroup", {
          name: this.name,
        });
        this.closeDialog();
      }
    },
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 10px;
}
</style>
